export { default } from './FeedCard';
